
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class EncryptionMatrixEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*";

        ctx.fillStyle = pc.color;
        ctx.font = `${12 * scale}px monospace`;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.4;
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    const idx = Math.floor(this.pseudoRandom(x + y + Math.floor(time * 5)) * alphabet.length);
                    const char = alphabet[idx];
                    ctx.fillText(char, x, y);
                    
                    // Grid lines
                    ctx.lineWidth = 0.5 * scale;
                    ctx.strokeStyle = pc.color;
                    ctx.strokeRect(x - spacing/2, y - spacing/2, spacing, spacing);
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
